/**
 * Los nombres que se ven de cada nivel de permiso, en un solo lugar (xcons-docs#510). Sólo cambia lo
 * que se muestra: los `value` que viajan a la API (`admin`, `editor`, `viewer`, `no_access`,
 * `by_relation`) siguen iguales.
 *
 * "Para todo" no es decorativo: el nivel vale para toda la tienda, el seller o el canal, no sólo para
 * lo propio (ver `pages/channels/ChannelPermissions`).
 */
export const NIVEL: Record<"no_access" | "viewer" | "editor" | "admin" | "by_relation", string> = {
  no_access: "No",
  viewer: "Lector",
  editor: "Editor",
  admin: "Admin",
  // Lo que ve quien participa (glosario: "atribución por participación").
  by_relation: "Por participación",
};

export const NIVEL_PARA_TODO: Record<"viewer" | "editor" | "admin", string> = {
  viewer: "Lector para todo",
  editor: "Editor para todo",
  admin: "Admin para todo",
};

/** El sufijo de un nivel que vale para todo, para los textos que lo arman a partir del nombre. */
export const PARA_TODO = "para todo";
